var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exam-container"},[_c('div',{staticClass:"exam-head"},[_c('router-link',{staticClass:"item",attrs:{"tag":"span","to":{name:'BindModify'}}},[_vm._v(" 绑定手机修改 ")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }